import { render, staticRenderFns } from "./centerscoreranking.vue?vue&type=template&id=3062393a&scoped=true"
import script from "./centerscoreranking.vue?vue&type=script&lang=js"
export * from "./centerscoreranking.vue?vue&type=script&lang=js"
import style0 from "./centerscoreranking.vue?vue&type=style&index=0&id=3062393a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062393a",
  null
  
)

export default component.exports